// import { portalService } from "apiServices";

export const ACTIVITY_FORM_RENDER_STATUS = (type) => {
  switch (type) {
    case "1":
      return {
        label: "รอประกาศผล",
        bg: "#FFB341",
      };
    case "2":
      return {
        label: "ปฏิเสธ",
        bg: "#FFB341",
      };
    case "3":
      return {
        label: "ถูกยกเลิกโดยระบบ",
        bg: "#FFB341",
      };
    case "4":
      return {
        label: "สำเร็จ",
        bg: "#008000",
      };
    case "5":
      return {
        label: "Draft",
        bg: "#FFB341",
      };
    case "6":
      return {
        label: "รอการตรวจสอบจากแอดมิน",
        bg: "#EAAE28",
      };
    case "7":
      return {
        label: "แอดมินแก้ไขข้อมูล/ตอบกลับลูกค้าแล้ว",
        bg: "transparent",
        txtColor: "#222020",
      };
    default:
      return {
        label: "-",
        bg: "#008000",
      };
  }
};

export const ACTIVITY_FORM_RENDER_CUS_STATUS = (type) => {
  switch (type) {
    case "1":
      return {
        label: "รอประกาศผล",
        bg: "#FFB341",
      };
    case "2":
      return {
        label: "ปฏิเสธ",
        bg: "#FFB341",
      };
    case "3":
      return {
        label: "ถูกยกเลิกโดยระบบ",
        bg: "#FFB341",
      };
    case "4":
      return {
        label: "สำเร็จ",
        bg: "#008000",
      };
    case "5":
      return {
        label: "Draft",
        bg: "#FFB341",
      };
    case "6":
      return {
        label: "ลูกค้าขอแก้ไขข้อมูล",
        bg: "transparent",
        txtColor: "#222020",
      };
    case "7":
      return {
        label: "รอลูกค้ายืนยันข้อมูล",
        bg: "#94E559",
      };
    default:
      return {
        label: "-",
        bg: "#008000",
      };
  }
};

export const REGISTER_BY = (type) => {
  switch (type) {
    case "1":
      return "บุคคล";
    case "2":
      return "องค์กร";
    case "3":
      return "ไม่เป็นสมาชิก";
    default:
      return "-";
  }
};

// export const RENDER_BELL_STATUS = async (id) => {
//   if (!id) return false;

//   try {
//     const res = await portalService.GET_ACTIVITY_FORM_HISTORY_BY_ACTIVITY_LIST(
//       id
//     );
//     const data = res?.data?.docs || [];

//     if (Array.isArray(data)) {
//       const statusFound = data.some((item) => item.status === "6");
//       return statusFound;
//     }

//     return false;
//   } catch (error) {
//     console.error("Error fetching activity form history:", error);
//     return false;
//   }
// };
